import {Row, Col, message, Layout} from "antd";
import React, {useEffect, useState} from "react";
import Header from "./components/Header";
import Footer from './components/Footer';
import NavLeft from './components/NavLeft';
import Logo from "./components/Logo"
import './admin.sass'
import './reset.css'
import {withRouter} from 'react-router-dom'
import {MenuFoldOutlined, MenuUnfoldOutlined} from "@ant-design/icons";
const { Sider, Content } = Layout;
const Admin = (props) => {
    const [collapsed, setCollapsed] = useState(false);
    return (
        <Layout className='admin'>
            <Sider className='navleft' trigger={null} collapsible collapsed={collapsed}>
                <Logo/>
                <NavLeft/>
            </Sider>
            <Layout className='navright'>
                <Header setCollapsed={() => {setCollapsed(!collapsed)}} collapsed = {collapsed}>
                </Header>
                <Content className="content">
                    <div className='mg20 paddingBottom20'>
                        {props.children}
                    </div>
                </Content>
                {/*<Footer/>*/}
            </Layout>
        </Layout>
    );
}
export default withRouter(Admin);